import { Box } from '@mui/material';
import * as Sentry from '@sentry/react';
import { HingeSelect } from '../modules/hinge-select';

export const HingeSelectPage = (): JSX.Element => (
  <Sentry.ErrorBoundary fallback={<Box>unable to load</Box>}>
    <HingeSelect />
  </Sentry.ErrorBoundary>
);
